/**
 * @file Constants — publicationLcaDatabaseOptions. Canonical LCA database dropdown options (mirrors backend seeder). */

export const PUBLICATION_LCA_DATABASE_OPTIONS: { label: string; value: string }[] = [
  { label: "Ecoinvent Version 3.12", value: "Ecoinvent Version 3.12" },
  { label: "Ecoinvent Version 3.11", value: "Ecoinvent Version 3.11" },
  { label: "Ecoinvent Version 3.10.1", value: "Ecoinvent Version 3.10.1" },
  { label: "Ecoinvent Version 3.10", value: "Ecoinvent Version 3.10" },
  { label: "Ecoinvent Version 3.9.1", value: "Ecoinvent Version 3.9.1" },
  { label: "Ecoinvent Version 3.9", value: "Ecoinvent Version 3.9" },
  { label: "Ecoinvent Version 3.8", value: "Ecoinvent Version 3.8" },
  { label: "Ecoinvent Version 3.7.1", value: "Ecoinvent Version 3.7.1" },
  { label: "Ecoinvent Version 3.7", value: "Ecoinvent Version 3.7" },
  { label: "Ecoinvent Version 3.6", value: "Ecoinvent Version 3.6" },
  { label: "Ecoinvent Version 3.5", value: "Ecoinvent Version 3.5" },
  { label: "Ecoinvent Version 3.4", value: "Ecoinvent Version 3.4" },
  { label: "Ecoinvent Version 3.3", value: "Ecoinvent Version 3.3" },
  { label: "Ecoinvent Version 3.2", value: "Ecoinvent Version 3.2" },
  { label: "Ecoinvent Version 3.1", value: "Ecoinvent Version 3.1" },
  { label: "Ecoinvent Version 3.0", value: "Ecoinvent Version 3.0" },
  { label: "Ecoinvent Version 2", value: "Ecoinvent Version 2" },
  { label: "GaBi Database", value: "GaBi Database" },
];

const LEGACY_LOWERCASE_ECOINVENT: Record<string, string> = Object.fromEntries(
  PUBLICATION_LCA_DATABASE_OPTIONS.filter((o) => o.value.startsWith("Ecoinvent")).map(
    (o) => [o.value.replace(/^Ecoinvent/, "ecoinvent"), o.value]
  )
);

/** Legacy values from the previous LCA software dropdown on this field. */
const LEGACY_LCA_DATABASE_LABELS: Record<string, string> = {
  ecochain: "Ecochain",
  gabi: "GaBi",
  oneclicklca: "OneClickLCA",
  openlca: "OpenLCA",
  simapro: "SimaPro",
  sphera_lca: "Sphera LCA",
};

/** Exported function — normalize Lca Database Stored Value. */
export function normalizeLcaDatabaseStoredValue(raw: unknown): string {
  if (raw == null || raw === "") return "";
  const value = String(raw).trim();
  if (!value) return "";
  return LEGACY_LOWERCASE_ECOINVENT[value] ?? value;
}

/** Exported function — resolve Lca Database Display Label. */
export function resolveLcaDatabaseDisplayLabel(raw: unknown): string {
  if (raw == null || raw === "") return "";
  const value = normalizeLcaDatabaseStoredValue(raw);
  if (!value) return "";

  const canonical = PUBLICATION_LCA_DATABASE_OPTIONS.find(
    (o) => o.value === value || o.label === value
  );
  if (canonical) return canonical.label;

  const legacy = LEGACY_LCA_DATABASE_LABELS[value.toLowerCase()];
  if (legacy) return legacy;

  return value;
}
